import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "children", "content", "className", "eventKey"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "acf2e7",
  styles: "padding:16px 0"
} : {
  name: "19cfboj-rootStyles",
  styles: "padding:16px 0;label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RhYlBhbmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFiUGFuZWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgVGFiUGFuZWxQcm9wcyB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gIHBhZGRpbmc6ICcxNnB4IDAnLFxufSk7XG5cbmNvbnN0IFRhYlBhbmVsOiBSZWFjdC5GQzxUYWJQYW5lbFByb3BzPiA9ICh7XG4gIGFjdGl2ZSxcbiAgY2hpbGRyZW4sXG4gIGNvbnRlbnQsXG4gIGNsYXNzTmFtZSxcbiAgZXZlbnRLZXksXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiB7XG4gIGlmICghYWN0aXZlKSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgICAgY3NzPXtyb290U3R5bGVzfVxuICAgICAgcm9sZT1cInRhYnBhbmVsXCJcbiAgICAgIHsuLi51bmhhbmRsZWRQcm9wc30+XG4gICAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogY29udGVudH1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cblRhYlBhbmVsLmRpc3BsYXlOYW1lID0gJ1RhYlBhbmVsJztcblxuZXhwb3J0IGRlZmF1bHQgVGFiUGFuZWw7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var TabPanel = function TabPanel(_ref) {
  var active = _ref.active,
      children = _ref.children,
      content = _ref.content,
      className = _ref.className,
      eventKey = _ref.eventKey,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  if (!active) {
    return null;
  }

  return jsx("div", _extends({
    className: className,
    css: rootStyles,
    role: "tabpanel"
  }, unhandledProps), children != null ? children : content);
};

TabPanel.displayName = 'TabPanel';
export default TabPanel;